import React from 'react';

import { Typography, TypographyVariant } from '@/components/_atoms/Typography';
import { usePriceParts } from '@/logic/price/usePrice';
import { cn } from '@/utils/styles.utils';

type Size = 'l' | 'xl' | 'xxl';

interface Props {
  price: string | null;
  oldPrice?: string | null;
  reverse?: boolean;
  size?: Size;
}

const priceVariantMap: Record<Size, TypographyVariant> = {
  l: 'header_xl',
  xl: 'header_price_xl',
  xxl: 'header_xxl',
};

const priceDecimalVariantMap: Record<Size, TypographyVariant> = {
  l: 'body_m',
  xl: 'body_m',
  xxl: 'body_xl',
};

const subVariantMap: Record<Size, TypographyVariant> = {
  l: 'body_s',
  xl: 'body_s',
  xxl: 'body_m',
};

export const ProductPrice = (props: Props) => {
  const formatPrice = usePriceParts();
  const { price, size = 'l' } = props;

  const emptyPrice = price === null;
  const [wholePart, fractionalPart] = formatPrice(price ?? 0);

  const priceVariant = priceVariantMap[size];
  const priceDecimalVariant = priceDecimalVariantMap[size];
  const subVariant = subVariantMap[size];
  return (
    <div className="flex items-baseline">
      {emptyPrice ? (
        <Typography variant={priceVariant} id="productDetails.price.empty" as="span" bold />
      ) : (
        <div className="flex gap-1">
          <Typography variant={priceVariant} as="span" bold>
            {wholePart}
          </Typography>
          <span
            className={cn('relative flex flex-col justify-end', {
              'pb-[3.5px]': size === 'l',
              'pb-[3px]': size === 'xl',
              'pb-[8px]': size === 'xxl',
            })}
          >
            <Typography
              className={cn('absolute', {
                'top-[4px]': size === 'l',
                'top-[2px]': size === 'xl',
                'top-[9px]': size === 'xxl',
              })}
              variant={priceDecimalVariant}
              bold
              as="span"
            >
              {fractionalPart}
            </Typography>
            <Typography variant={subVariant} color="grey-semi" as="span" id="productBox.price.perOne" />
          </span>
        </div>
      )}
    </div>
  );
};
